import { isPlatformBrowser } from '@angular/common'
import { Inject, Injectable, NgZone, PLATFORM_ID } from '@angular/core'
import { Subject, fromEvent } from 'rxjs'

@Injectable({
  providedIn: 'root',
})
export class ClickHandlerService {
  private clickSubject = new Subject<Event>()
  public click$ = this.clickSubject.asObservable()

  constructor(
    private ngZone: NgZone,
    @Inject(PLATFORM_ID) private platformId: object,
  ) {
    if (isPlatformBrowser(this.platformId)) {
      this.ngZone.runOutsideAngular(() => {
        fromEvent(document, 'click').subscribe((event: Event) => {
          this.ngZone.run(() => {
            this.clickSubject.next(event)
          })
        })
      })
    }
  }
}
